module.exports = __webpack_public_path__ + "01a1b63bf0ec3c54cb3e71d999cbcd8d.svg";